module.exports = __webpack_public_path__ + "img/mfd_in_2_inp4.2e52a9d3.png";